enum EstadosModalAuditoria {
    CERRADO = 'CERRADO',
    CREACION = 'CREACION',
    GESTION = 'GESTION',
    VISUALIZACION = 'VISUALIZACION',
}

export { EstadosModalAuditoria };
